/**
 * Generate initials from a name string.
 *
 * @param name - Full name to extract initials from (e.g., "John Smith")
 * @param maxLength - Maximum number of initials to return (default: 2)
 * @returns Uppercase initials (e.g., "JS")
 *
 * @example
 * getInitials("John Smith") // "JS"
 * getInitials("Alice Bob Charlie", 3) // "ABC"
 * getInitials("") // ""
 * getInitials(undefined) // ""
 */
export function getInitials(
  name: string | undefined | null,
  maxLength = 2
): string {
  if (!name) return "";

  return name
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, maxLength)
    .join("");
}
